import React, { useState, useEffect } from "react";
import { ChevronUp } from "lucide-react";

interface ScrollToTopProps {
  className?: string;
  showAfter?: number; 
}

const ScrollToTop = ({ 
  className = "",
  showAfter = 100 
}: ScrollToTopProps) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setIsVisible(scrollTop > showAfter);
    };

    window.addEventListener("scroll", handleScroll);
    
    // 초기 상태 체크
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [showAfter]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  if (!isVisible) {
    return null;
  }

  return (
    <button
      onClick={scrollToTop}
      className={`
        fixed bottom-12 right-12 z-50
        w-14 h-14 bg-black/90 backdrop-blur-sm border border-gray-200/60
        rounded-full shadow-lg
        flex items-center justify-center
        text-white hover:bg-black
        transform transition-all duration-300 ease-in-out
        hover:scale-105 hover:shadow-xl
        ${className}
      `}
      aria-label="맨 위로 이동"
    >
      <ChevronUp className="w-6 h-6" />
    </button>
  );
};

export default ScrollToTop; 